import script from "./ScrollAreaWrapper.vue?vue&type=script&lang=ts"
export * from "./ScrollAreaWrapper.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__